import React from 'react'
import { connect } from 'react-redux'
import { CommitteeApproveContainer } from './styled'
import GeneralInformation from '../ShortListPart/GeneralInformation'
import VendorInformation from './VendorInformation'
import AttachmentInformation from '../ShortListPart/AttachmentInformation'
import SubmitForm from '../SubmitForm'

const CommitteeApprove = (props) => {
  const { valueForm, change, handleSubmit } = props
  return (
    <CommitteeApproveContainer>
      <GeneralInformation valueForm={valueForm} change={change} isDisplay />
      <VendorInformation valueForm={valueForm} change={change} />
      <SubmitForm valueForm={valueForm} change={change} handleSubmit={handleSubmit} history={props.history} />
      <AttachmentInformation valueForm={valueForm} change={change} isDisplay />
    </CommitteeApproveContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    
  })
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CommitteeApprove)